<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
        <g clip-path="url(#clip0_1439_1652)">
            <path d="M16.0832 12.6453V13.9207C16.083 14.4279 15.8814 14.9143 15.5228 15.2729C15.1641 15.6316 14.6777 15.8331 14.1705 15.8333H3.32917C2.8219 15.8333 2.33541 15.6318 1.97671 15.2731C1.61802 14.9144 1.4165 14.4279 1.4165 13.9207V12.6453" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.75 12.572V1.16666" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.4168 7.90533L8.75016 12.572L4.0835 7.90533" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_1439_1652">
                <rect width="16" height="16" fill="white" transform="translate(0.75 0.5)"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: "IconDownload"
}
</script>

<style scoped>

</style>
